module.exports = __webpack_public_path__ + "static/media/38-5.b5bc25e5.mp3";